import { createSelector } from "reselect";
import { AppState } from "./index";

export const primaryAccounts = createSelector(
  (state: AppState) => state.report.summary,
  (r: AppState["report"]["summary"]) => r.filter(a => a.primary)
);
export const secondaryAccounts = createSelector(
  (state: AppState) => state.report.summary,
  (r: AppState["report"]["summary"]) => r.filter(a => !a.primary)
);



// WEBPACK FOOTER //
// ./src/redux/selectors.ts